import { ActionHandler } from "..";
import {
  getRecommendedHealthPlan,
  NON_MED_PLAN,
} from "src/utils/health/planRecommendation";
import {
  MED_SKU,
  getEligibleMedProducts,
  getEligibleMedProductsPlanSelection,
} from "src/utils/medEligibility";
import { setHealthPlansInRecommendationContext } from "src/utils/redux/slices/recommendationContext";
import { getPlanKeyAndDuration } from "src/utils/calculateGoals";
import { DEFAULT_NW_PLAN_DURATION_MED } from "src/utils/constants";
import { getMedPlanKeyBySKU, getNoomPlanIdFromKey } from "src/utils/plans";
import { setRecommendedPlanById } from "src/utils/redux/slices/recommendedPlan";
import getStore from "src/utils/redux/store";

/**
 * Action to determine and set the recommended plan for health route.
 */
export const loadRecommendedHealthPlan: ActionHandler = async () => {
  const recommendedPlan = getRecommendedHealthPlan();

  if (!recommendedPlan) {
    return;
  }

  if (Object.values(MED_SKU).includes(recommendedPlan as any)) {
    const recommendedMedTier = recommendedPlan as MED_SKU;
    const eligibleMedProducts = getEligibleMedProducts();
    const eligibleMedTiers = getEligibleMedProductsPlanSelection(
      recommendedMedTier,
      eligibleMedProducts
    );

    setHealthPlansInRecommendationContext(
      recommendedPlan as MED_SKU, // recommendedHealthPlan (for all plans)
      recommendedMedTier, // recommendedMedTier (same value for med plans)
      eligibleMedTiers
    );
  } else {
    setHealthPlansInRecommendationContext(recommendedPlan);
  }

  let selectedPlanId: string | null = null;
  if (recommendedPlan === NON_MED_PLAN.NOOM_WEIGHT) {
    const { planKey } = getPlanKeyAndDuration(
      DEFAULT_NW_PLAN_DURATION_MED,
      false
    );
    selectedPlanId = getNoomPlanIdFromKey(planKey as string);
  } else if (Object.values(MED_SKU).includes(recommendedPlan as any)) {
    const medPlanKey = getMedPlanKeyBySKU(recommendedPlan as MED_SKU);
    if (medPlanKey) {
      selectedPlanId = getNoomPlanIdFromKey(medPlanKey as string);
    }
  }

  if (selectedPlanId) {
    await getStore().dispatch(
      setRecommendedPlanById(selectedPlanId, {
        overwriteReset: true,
        overwriteForced: true,
      })
    );
  }
};
